// import React, { useState, useEffect } from "react";
// import Header1 from "../../components/header1/Header1";
// import Footer from "../../components/footer/Footer";
// // import "./registration.css";
// import jsonData from "../../utils/statesAndCities.json";
// import bannerImage1 from '../../elements/hero-banner-registration-page.png';
// import bannerImage2 from '../../elements/hero-banner-landing-page.png';
// import RegistrationConfirmation from "../confirmation/Confirmation";
// import { useDispatch, useSelector } from "react-redux";
// import { TiTick } from "react-icons/ti";
// import mobileBannerImage from '../../elements/mobile_bg.png';
// import {
//   setCollegeData,
//   resetForm,
//   setCurrentSection,
// } from "./registrationSlice";
// import CollegeDetails from "./collegedetails/collegeDetails";
// import UserInfo from "./userinfo/userInfo";
// import { getCollegeData } from "../../services/studentportalapis";
// import { useLoaderData, useLocation } from "react-router-dom";
// import LinkedInFollow from "../linkedIn_follow/LinkedIn";

// const Registration = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const formData = useSelector((store) => store.registration);
//   const currentSection = formData.currentSection;
//   const location = useLocation();

//   const collegeDetails = useLoaderData();
//   // collegeDetails.map((college) => console.log(college));
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(setCollegeData(collegeDetails));
//   }, [dispatch, collegeDetails]);

//   useEffect(() => {
//     dispatch(resetForm());
//   }, [dispatch]);

//   useEffect(() => {
//     const handleBackButtonEvent = (event) => {
//       if (location.pathname === "/register") {
//         // User is on the register page
//         window.addEventListener("popstate", () => {
//           dispatch(resetForm()); // Dispatch the action to clear Redux state
//         });
//       }
//     };

//     // Attach the event listener
//     handleBackButtonEvent();

//     return () => {
//       // Clean up the event listener when component unmounts or route changes
//       window.removeEventListener("popstate", handleBackButtonEvent);
//     };
//   }, [location, dispatch]);


//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener('resize', handleResize);

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);


//   return (
//     <div className="md:mx-20">
//       <Header1 />
//       <div className="relative w-full">
//         {!isMobile && (
//           <div>
//             <img
//               src={currentSection === 3 ? bannerImage2 : bannerImage1}
//               alt="Banner"
//               className="w-full sm:mx-auto object-cover"
//             />
//             <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-normal">
//               <div className="flex flex-col w-11/12 md:w-2/5 lg:w-2/5 md:p-4 md:ml-8 sm:ml-0">
//                 <p className="text-xl font-medium sm:text-xl md:text-3xl leading-none mb-1 text-left">
//                   Join Agivant's
//                 </p>
//                 <p className="text-xl font-medium sm:text-xl md:text-3xl leading-none mb-1 text-left">
//                   transformative program
//                 </p>
//                 <p className="text-xl font-medium sm:text-xl md:text-3xl leading-none mb-1 text-left">
//                   and master the skills to
//                 </p>
//                 <p className="text-xl font-medium sm:text-xl md:text-3xl leading-none mb-1 text-left">
//                   AI-driven software
//                 </p>
//                 <p className="text-xl font-medium sm:text-xl md:text-3xl leading-none mb-1 text-left">
//                   development
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}
//         </div>

//         <div
//           className="bg-cover bg-center"
//           style={{
//             backgroundImage: `url(${isMobile ? mobileBannerImage : ""})`,
//           }}>
//           <div className="">
//             <h1 className="text-white md:!text-black py-4 md:!py-6  font-bold text-center text-3xl">Registration Details</h1>

//             <div className="relative flex items-center justify-between w-11/12 sm:w-full max-w-4xl mx-auto my-10">
//               <div className="mt-4 absolute top-1/2 left-0 right-0 h-0.5 bg-black z-0"></div>

//               <div className="relative z-10 flex-1 flex flex-col items-start">
//                 <span className={`sm:mb-6 text-base sm:text-lg md:text-xl font-bold mb-4 ${currentSection === 1 ? 'text-blue-500' :
//               currentSection >= 2 ? 'text-green-500' : 'text-white md:!text-gray-400'
//               }`}>Personal Information</span>
//             <div
//               className={`mt-4 w-6 h-6 rounded-full absolute top-1/2 transform -translate-y-1/2 left-0 mb-4 ${currentSection === 1 ? 'bg-blue-500' :
//                 currentSection >= 2 ? 'bg-green-500' : 'bg-gray-400'
//                 }`}
//             ></div>
//           </div>

//           <div className="relative z-10 flex-1 flex flex-col items-center">
//             <span className={`sm:mb-6 text-base text-center sm:text-lg md:text-xl font-bold mb-4 ${currentSection === 2 ? 'text-blue-500' :
//               currentSection >= 3 ? 'text-green-500' : 'text-white md:!text-gray-400'
//               }`}>Application details</span>
//             <div
//               className={`mt-4 w-6 h-6 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${currentSection === 2 ? 'bg-blue-500' :
//                 currentSection >= 3 ? 'bg-green-500' : 'bg-white md:!bg-gray-400'
//                 }`}
//             ></div>
//           </div>

//           {/* Registration Status */}
//         <div className="relative z-10 flex-1 flex flex-col items-end">
//           <span className={`sm:mb-6 text-base text-right sm:text-lg md:text-xl font-bold mb-4 ${currentSection === 3 ? "text-blue-500" : 
//           currentSection === 4 ? "text-green-500" : "text-white md:!text-gray-400"
//             }`}>Registration Status</span>
//           <div
//             className={`mt-4 w-6 h-6 rounded-full absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 ${currentSection === 3 ? "bg-blue-500" : 
//               currentSection === 4 ? "bg-green-500" : "bg-white md:!bg-gray-400"
//             }`}
//           >
//             {currentSection === 4 && (
//               <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
//                 <TiTick size="100%" />
//               </div>
//             )}
          
//           </div>

//               </div>
//             </div>
//           </div>

//       <div className=" ">
//         {currentSection === 1 && (
//           <div className="">
//             <UserInfo />
//           </div>
//         )}
//         {currentSection === 2 && (
//           <div className="">
//             <CollegeDetails />
//           </div>
//         )}
//         {currentSection === 3 && (
//           <div className="">
//             <LinkedInFollow />
//           </div>
//         )}
//         {currentSection === 4 && (
//           <div className="">
//             <RegistrationConfirmation />
//           </div>
//         )}
//       </div>
//         </div>
//         <Footer />
//     </div>
//   );
// };

// export async function loader() {
//   const collegeData = await getCollegeData();
//   localStorage.setItem("CollegeData",collegeData);
//   return collegeData;
// }

// export default Registration;


//----------------------------------------------------Regiteration closed------------------------------------------------

import React from "react";
import Header1 from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";

const Registration = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <Header1 />

      <div className="flex-grow flex items-center justify-center px-4">
        <div className="bg-white shadow-2xl rounded-2xl p-8 max-w-lg w-full text-center animate-fadeIn">
          <h1 className="text-4xl font-extrabold text-gray-800 mb-4">
            🚫 Registration Closed
          </h1>
          <p className="text-gray-600 text-lg">
            Thank you for your interest. Registration for this program is now closed. 
            Please check back later for upcoming opportunities.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

// ✅ Keep loader so App.js doesn't break
export async function loader() {
  return [];
}

export default Registration;